import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import StickerFairyLogo from '../assets/img/StickerFairyLogo.jpg';

export const STICKER_FAIRY_DEAL_CHECKOUT_BASE_URL =
  'https://pay.rev.cat/kiabgvszhgwftvfi';
export const STICKER_FAIRY_DEAL_PATH = '/disneyland/sticker-fairy-deal';

export const buildStickerFairyDealCheckoutUrl = (userId: string) =>
  `${STICKER_FAIRY_DEAL_CHECKOUT_BASE_URL}/${encodeURIComponent(userId)}`;

const dealItems = [
  'Sticker Fairy access',
  '10,000 MouseWait credits',
  'ALL-ACCESS',
];

const StickerFairyDeal = () => {
  const navigate = useNavigate();
  const userId = localStorage.getItem('user_id') || '';
  const checkoutUrl = userId ? buildStickerFairyDealCheckoutUrl(userId) : '#';

  const handleCheckoutClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (userId) {
      return;
    }

    event.preventDefault();
    navigate('/disneyland/login', {
      state: { returnTo: STICKER_FAIRY_DEAL_PATH, source: 'StickerFairyDeal' },
    });
  };

  return (
    <>
      <Helmet>
        <title>Sticker Fairy + 10,000 Credits + ALL-ACCESS | MouseWait</title>
        <meta
          name="description"
          content="Get Sticker Fairy, 10,000 MouseWait credits, and ALL-ACCESS in one $99 MouseWait deal."
        />
      </Helmet>

      <main className="mw-sticker-fairy-deal" aria-labelledby="sticker-fairy-deal-title">
        <section className="mw-sticker-fairy-deal__hero">
          <img
            className="mw-sticker-fairy-deal__logo"
            src={StickerFairyLogo}
            alt="Sticker Fairy"
          />
          <div className="mw-sticker-fairy-deal__copy">
            <p className="mw-sticker-fairy-deal__eyebrow">Limited MouseWait deal</p>
            <h1 id="sticker-fairy-deal-title">
              Sticker Fairy + 10,000 Credits + ALL-ACCESS
            </h1>
            <p className="mw-sticker-fairy-deal__lead">
              Get the Sticker Fairy creator, a 10,000 credit boost, and ALL-ACCESS in
              one package for $99.
            </p>
            <div className="mw-sticker-fairy-deal__price" aria-label="Price">
              $99
            </div>
            <a
              className="mw-sticker-fairy-deal__checkout"
              href={checkoutUrl}
              onClick={handleCheckoutClick}
              rel="noopener noreferrer"
            >
              {userId ? 'Buy now' : 'Log in to buy'}
            </a>
          </div>
        </section>

        <section className="mw-sticker-fairy-deal__details" aria-label="Deal details">
          <div>
            <h2>Included</h2>
            <ul>
              {dealItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <div>
            <h2>After payment</h2>
            <p>
              Your ALL-ACCESS deal turns on automatically, and 10,000 credits are
              added to your MouseWait account.
            </p>
          </div>
        </section>

        <section className="mw-sticker-fairy-deal__terms" aria-label="Deal terms">
          <h2>Deal terms</h2>
          <p>
            This is a one-time MouseWait purchase. After successful payment, the
            RevenueCat purchase grants the ALL-ACCESS entitlement and adds 10,000
            MouseWait credits to your account.
          </p>
        </section>
      </main>
    </>
  );
};

export default StickerFairyDeal;
